import { useMemo } from "react";
import { useTaxonomyContext } from "../contexts/Taxonomy/TaxonomyContext";
import { useAiSpendCategories } from "../lib/company-filter/modules/aiSpend/useAiSpendCategories";
import type { HgSpendCategory } from "../types/taxonomy";
import type { TamSpendType } from "../types/workspace";

export const useTamSpendCategories = (
  spendType: TamSpendType | null | undefined
): HgSpendCategory[] => {
  const { spendCategories } = useTaxonomyContext();
  const aiSpendCategories = useAiSpendCategories();

  return useMemo(
    () =>
      spendType === "AI"
        ? aiSpendCategories.map((category) => ({
            ...category,
            description: "",
          }))
        : spendCategories,
    [spendType, aiSpendCategories, spendCategories]
  );
};
